import { Injectable } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { MediaDevice } from '../../models/user-device.model';
import { availableDeviceDataServiceConfig } from '../available-devices.entity';

@Injectable()
export class AvailableDevicesSelectors {

    private availableDevicesService: EntityCollectionService<MediaDevice>;
    private entities$: Observable<Array<MediaDevice>>;

    constructor(private entityServices: EntityServices) {
        this.availableDevicesService =
            this.entityServices.getEntityCollectionService<MediaDevice>(availableDeviceDataServiceConfig.entityName);
        this.entities$ = this.availableDevicesService.entities$;
    }

    selectSMSDevices(): Observable<Array<MediaDevice>> {
        return this.entities$
            .pipe(map(devices => devices.filter(device => device.deviceId.indexOf('sms') > -1)));
    }

    selectEmailDevices(): Observable<Array<MediaDevice>> {
        return this.entities$
            .pipe(map(devices => devices.filter(device => device.deviceId.indexOf('email') > -1)));
    }

    selectVoiceDevices(): Observable<Array<MediaDevice>> {
        return this.entities$
            .pipe(map(devices => devices.filter(device => device.deviceId.indexOf('voice') > -1)));
    }

}
